<template>
  <v-card v-if="currentUser">
    <v-card-title>
      {{ $t("nav.user.auditPeriods") }}
    </v-card-title>

    <v-simple-table>
      <template #default>
        <thead>
          <tr>
            <th>{{ $t("user.auditPeriods.year") }}</th>
            <th>{{ $t("user.auditPeriods.funds") }}</th>
            <th width="1%"></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="auditPeriod in auditPeriods" :key="auditPeriod.id">
            <td>
              {{ auditPeriod.year }}
            </td>

            <td>
              {{ auditPeriod.funds.length }}
            </td>

            <td width="1%">
              <v-btn :to="{ name: 'userAuditPeriod', params: { id: auditPeriod.id } }" color="secondary" icon>
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import AuditPeriodsQuery from "@/gql/queries/AuditPeriodsQuery.gql";

export default {
  data() {
    return {
      currentUser: null,
    };
  },

  computed: {
    auditPeriods() {
      return this.currentUser?.auditPeriods?.slice().sort((a, b) => b.year - a.year);
    },
  },

  apollo: {
    currentUser: {
      query: AuditPeriodsQuery,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
